import Box from '@mui/material/Box'
import { FC } from 'react'
import { DataLoad, DataLoggerList } from 'src/components'
import { defaultPage, defaultPerPage } from 'src/config'
import { useDataLoggerListRequest } from 'src/hooks/api'
import { useQueryParams } from 'src/hooks/ui'
import { DataLoggerGridColumns } from 'src/components/sections/dataLogger/dataLoggerColumns'

interface Props {
  projectId: number;
}

const initialQueryParams = {
  page: `${defaultPage}`,
  rowsPerPage: `${defaultPerPage}`,
}
const columns = [
  DataLoggerGridColumns.DeviceId,
  DataLoggerGridColumns.Status,
  DataLoggerGridColumns.Label,
  DataLoggerGridColumns.Interval,
  DataLoggerGridColumns.FirstReadingDateTime,
  DataLoggerGridColumns.LastReadingDateTime,
  DataLoggerGridColumns.LastUploadDateTime,
  DataLoggerGridColumns.Section,
  DataLoggerGridColumns.BatteryLevel,
  DataLoggerGridColumns.CreatedAt,
]

export const ProjectDataLoggerList: FC<Props> = ({
  projectId,
}) => {
  const [queryParams, setQueryParams] = useQueryParams(initialQueryParams)
  const { isInitialLoading, isError, error, data } = useDataLoggerListRequest({
    params: {
      projectId,
      ...queryParams,
    },
  })
  const exportedFileName = `${document.title}_data-pucks`

  return (
    <DataLoad isLoading={false} isError={isError} errorMessage={error?.message}>
      <Box height="500px">
        <DataLoggerList
          dataLoggerCount={data?.count || 0}
          dataLoggers={data?.rows || []}
          isLoading={isInitialLoading}
          setQueryParams={setQueryParams}
          queryParams={queryParams}
          autoHeight={false}
          exportedFileName={exportedFileName}
          tableColumns={columns}
        />
      </Box>
    </DataLoad>
  )
}
